export interface ExportJobDownloadUrl {
  downloadUrl: string
}

export class ExportJobDownloadUrlDTO implements ExportJobDownloadUrl {
  downloadUrl: string

  constructor(downloadUrl: string) {
    this.downloadUrl = downloadUrl
  }

  static fromJSON(jsonObject: ExportJobDownloadUrl): ExportJobDownloadUrlDTO {
    return new ExportJobDownloadUrlDTO(
      jsonObject.downloadUrl,
    )
  }
}
